// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDarvalueIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDarvalueIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDarvalueIconOutlined = function DrrpDarvalueIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDarvalueIconOutlinedSvg
  }));
};

DrrpDarvalueIconOutlined.displayName = 'DrrpDarvalueIconOutlined';
export default React.forwardRef(DrrpDarvalueIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDarvalueIconOutlined.js
// module id = 2536
// module chunks = 0